<template>
  <div class="page-calendar">

    <div class="WEB-actions col-24 no-padding">
      <el-button class="WEB-button WEB-button-header left filtri"
        @click="() => { filtriActive ? closeFiltri() : openFiltri() }">
        <div class="filtri-div">
          <div class="icon-left">
            <icon name="riv-filter" scale="1.4"></icon>
          </div>
          <div class="label">{{ $t('btn.filtri') }}</div>
          <div style="width: 20px"></div>
        </div>
      </el-button>
      <el-button class="WEB-button WEB-button-icon-transparent right prec" @click="changeMonth(-1)">
        <icon name="riv-arrow" scale="1.2" flip="horizontal"></icon>
      </el-button>
      <span v-if="filtro.date" class="titolo">{{ $t('calendar.mesi.' + filtro.date.substr(4, 6), {
        year:
          filtro.date.substr(0, 4)
      }) }}</span>
      <el-button class="WEB-button WEB-button-icon-transparent right prec" @click="changeMonth(1)">
        <icon name="riv-arrow" scale="1.2"></icon>
      </el-button>
      <el-button class="WEB-button WEB-button-header-icon right" @click="stampa()">
        <icon name="riv-printTrack" scale="1.2"></icon>
      </el-button>
      <span class="WEB-legenda" @click="showModalLegenda = true"
        style="float: right; padding-right: 15px; cursor: pointer;">{{ $t('btn.legenda') }}</span>
    </div>

    <div class="WEB-body col-24 no-padding" v-loading="loading">

      <!-- Filtri -->
      <div class="WEB-filtri" v-show="filtriActive">
        <div class="WEB-filtri-content">
          <div class="row">
            <!--<div class="WEB-filtri-title col-24">
              {{$t('filtri.selFiltri')}}
            </div>-->
            <div class="WEB-filtri-label col-24">
              {{ $t('calendar.impiegato') }}
            </div>
            <div class="WEB-filtri-input col-24" style="margin-bottom: 40px;">
              <!--<el-select v-model="filtro.employee" class="WEB-select" filterable clearable value-key="ccDipendente"
                @change="selectEmployee()">
                <el-option v-for="item in list_Employees" :key="item.ccDipendente" :label="item.employee" :value="item">
                </el-option>
              </el-select>-->
              <el-select class="WEB-select" v-model="filtro.employee" :placeholder="$t('filtri.selkeyword')"
                :filterable="true" :remote="true" :loading="loading_employee" :reserve-keyword="false" :multiple="false"
                :remote-method="((query) => { if (query.length >= 3) load_Employees(query) })" value-key="ccDipendente"
                clearable @change="selectEmployee()">
                <el-option v-for="item in list_Employees" :label="item.employee" :key="item.ccDipendente" :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="WEB-filtri-label col-24">
              {{ $t('country.label') }}
            </div>
            <div class="WEB-filtri-input col-24">
              <el-select v-model="filtro.country" class="WEB-select" @change="changeCountry(false)" value-key="codice"
                :disabled="filtro.employee.country !== undefined">
                <el-option v-for="item in countries" :key="item.codice" :label="($t('country.' + item.codice))"
                  :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="WEB-filtri-label col-24" v-if="filtro.country.seVip === 'Y'">
              {{ $t('calendar.vip') }}
              <el-checkbox v-model="filtro.vip" class="WEB-checkbox" style="margin-left: 20px;"></el-checkbox>
            </div>
            <div class="WEB-filtri-label col-24">
              {{ $t('calendar.company') }}
            </div>
            <div class="WEB-filtri-input col-24">
              <el-select v-model="filtro.company" class="WEB-select" @change="changeCompany()" value-key="codice"
                clearable :disabled="filtro.employee.country !== undefined">
                <el-option v-for="item in list_Company" :key="item.codice" :label="item.descrizione"
                  :value="item.codice">
                </el-option>
              </el-select>
            </div>
            <div class="WEB-filtri-label col-24">
              {{ $t('calendar.groups') }}
            </div>
            <div class="WEB-filtri-input col-24">
              <el-select v-model="filtro.group" class="WEB-select" value-key="codice" clearable
                :disabled="filtro.employee.country !== undefined">
                <el-option v-for="item in list_Groups" :key="item.codice" :label="item.descrizione"
                  :value="item.codice">
                </el-option>
              </el-select>
            </div>
            <div class="WEB-filtri-label col-24">
              {{ $t('calendar.cecoCoi') }}
            </div>
            <div class="WEB-filtri-input col-24">
              <el-select v-model="filtro.cecoCoi" class="WEB-select" value-key="codice" clearable
                :disabled="filtro.employee.country !== undefined">
                <el-option v-for="item in list_CecoCoi" :key="item.codice" :label="item.descrizione"
                  :value="item.codice">
                </el-option>
              </el-select>
            </div>
            <div class="WEB-filtri-label col-24">
              {{ $t('calendar.mese') + '/' + $t('calendar.anno') }}
            </div>
            <div class="WEB-filtri-input col-24">
              <el-date-picker v-model="filtro.date" type="month" format="MMM yyyy" value-format="yyyyMM" placeholder=""
                :clearable="false">
              </el-date-picker>
            </div>
            <div class="WEB-filtri-label col-24">
              {{ $t('calendar.calend') }}
            </div>
            <div class="WEB-filtri-input col-24" style="height: 100% !important">
              <el-select v-model="filtro.typologies" multiple placeholder="" class="WEB-select-multiple"
                @change="changeAll" @remove-tag="removell">
                <el-option v-for="item in list_Typologies" :key="item.codice" :label="item.descrizione"
                  :value="item.codice">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="filtri-footer row">
          <div class="col-12 filtri-button-sx">
            <el-button class="WEB-button WEB-button-alternative" @click="svuotaCampi()">
              {{ $t('btn.svuotaCampi') }}
            </el-button>
          </div>
          <div class="col-12 filtri-button-dx">
            <el-button class="WEB-button WEB-button-primary central" @click="cerca()">
              {{ $t('btn.cerca') }}
            </el-button>
          </div>
        </div>
      </div>
      <div class="mask-div" v-show="filtriActive" @click="closeFiltri" />
      <!-- END Filtri -->

      <!-- TABLE CALENDAR -->
      <el-table :border="true" class="custom-table table-ferie" :cell-class-name="getCellClassName"
        :data="tbl_calendario" style="width: 100%" :height="100 % - 56 - 50 - 50 - 60 - 5 - 10"
        :row-key="(row) => row.ccDipendente">
        <el-table-column prop="date" :label="($t('calendar.impiegato').toUpperCase())" width="160">

          <!--<template slot-scope="scope" slot="header">
            <div class="name-wrapper">
              <el-input :placeholder="$t('calendar.impiegato')" v-model="filtro.employeeTable" style="width: 90%;" :input="changeInput()" class="filtro-employee">
            </el-input>
            </div>
          </template>-->
          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ scope.row.surname }} {{ scope.row.name.substr(0, 3) }}.
            </div>
          </template>

        </el-table-column>

        <el-table-column v-for="(cont, index) in counter" :key="'cont_' + index.toString()" header-align="center"
          align="center" width="45">

          <template slot-scope="scope" slot="header">
            <div class="header-giorni" :key="'cont_' + scope.$index">
              <div class="label-giorno col-24 no-padding float-left">
                {{ $t('calendar.cont.' + countrySearch + '.' + index + '.desc') }}
              </div>
              <div class="numero col-24 no-padding float-left">
                {{ $t('calendar.cont.' + countrySearch + '.' + index + '.unit') }}
              </div>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="name-wrapper">
              {{  index < scope.row.cont.length ? scope.row.cont[index].value : ' '}}
            </div>
          </template>

        </el-table-column>

        <el-table-column v-for="(giorno, index) in giorni" width="40" :key="index" header-align="center" align="center"
          :class-name="getColumnCellClass(giorno)" :column-key="index.toString()">

          <template slot-scope="scope" slot="header"
            v-if="calendarioAttrib.hasOwnProperty('gg' + giorno) || calendarioAttrib.hasOwnProperty('fe' + giorno)">
            <div class="header-giorni" :key="'giorno_' + scope.$index">
              <div class="label-giorno col-24 no-padding float-left">
                {{ $t('calendar.' + ((calendarioAttrib.hasOwnProperty('fe' + giorno)) ? calendarioAttrib['fe' + giorno]
                  :
                  calendarioAttrib['gg' + giorno])) }}
              </div>
              <div class="numero col-24 no-padding float-left">
                {{ giorno }}
              </div>
            </div>
          </template>

          <template slot-scope="scope">
            <div class="giorno col-24 no-padding" @click="dettaglio(scope.row, giorno)">
              {{ scope.row.hasOwnProperty('day' + giorno) ? scope.row['day' + giorno].des : '' }}
            </div>
          </template>

        </el-table-column>
      </el-table>
      <!-- carico il component con il calendario personalizzato per ognio stato -->
      <el-pagination class="custom-pagination" layout="prev, pager, next" :current-page="currentPage" :total="nrItems"
        :page-size="pag_for" @current-change="changePage" v-if="(nrItems > 0 && nrItems > pag_for)">
      </el-pagination>

    </div>

    <!-- MODAL DETTAGLIO GIORNALIERO -->
    <el-dialog :title="($t('calendar.modalGiornoTitolo', { nome: employee }).toUpperCase())"
      :visible.sync="showModalGiorno" class="custom-dialog WEB-dialog" :append-to-body="true"
      custom-class="offset-5 col-14" :before-close="closeModalGiorno">

      <el-tabs v-model="tabActivity" type="card" class="col-24 el-tabs-ferie">
        <el-tab-pane v-for="(activity, index) in giorno" :key="index">
          <div style="width: 150px" slot="label" @click="changeActivity(index)">
            <div class="app-name">
              <!--<span>{{ $t('calendar.' + activity.type) }}</span>-->
              {{ getTipology(activity) }}
            </div>
            <div class="col-24 no-padding barra"></div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <!-- TRASFERTA START -->
      <div
        v-if="giorno.length > 0 && giorno[activity_select].macrotype === 'TRASFERTE' && giorno[activity_select].id !== ''"
        v-loading="loading_giorno">
        <el-form class="WEB-form">
          <div class="elemento row row-custom">
            <div class="WEB-form-label col-8">
              {{ $t('calendar.note') }}
            </div>
            <div class="WEB-form-value col-16">
              {{ giorno[activity_select].ore === '' ? giorno[activity_select].note : giorno[activity_select].ore + ' - '
                +
                giorno[activity_select].note }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="WEB-form-label col-8">
              {{ $t('trasferte.periodo') }}
            </div>
             <div class="WEB-form-value col-16" v-if="trasferta.tipoTrasferta === 'ORE'">
              {{ trasferta.dataDal | formatDate }} {{ '(' + trasferta.oraDal + ' - ' + trasferta.oraAl +')'}}
            </div>
            <div class="WEB-form-value col-16" v-else>
              {{ trasferta.dataDal | formatDate }} - {{ trasferta.dataAl | formatDate }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="WEB-form-label col-8">
              {{ $t('trasferte.partenza') }} / {{ $t('trasferte.destinazione') }}
            </div>
            <div class="WEB-form-value col-16">
              {{ trasferta.desProv }} / {{ trasferta.desDest === undefined ? trasferta.desMan : trasferta.desDest }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="WEB-form-label col-8">
              {{ $t('trasferte.soc') }}
            </div>
            <div class="WEB-form-value col-16">
              {{ trasferta.desCli }} <span style="text-transform: capitalize">( {{ trasferta.desUff !== undefined ?
                trasferta.desUff.toLowerCase() : '' }} )</span>
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="WEB-form-label col-8">
              {{ $t('trasferte.referente') }}
            </div>
            <div class="WEB-form-value col-16">
              {{ trasferta.perRif ? trasferta.perRif + '; ' : '' }}
              <span v-for="tag in trasferta.contatti" :key="tag.mail">
                {{ tag.mail + '; ' }}
              </span>
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="WEB-form-label col-8">
              {{ $t('trasferte.motivo') }}
            </div>
            <div class="WEB-form-value col-16">
              <div class="testata-value col-md-16 col-14"
                v-html="trasferta.notaDip !== undefined ? trasferta.notaDip.replace(/\\n|\\r\\n|\\n\\r|\\r/g, '<br>') : ''"
                style="white-space: pre-line"></div>
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="WEB-form-label col-8">
              {{ $t('trasferte.notaResp') }}
            </div>
            <div class="WEB-form-value col-16">
              <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 4 }" placeholder=""
                v-model="trasferta.notaResp" :disabled="trasferta.statoAvanz !== '1'">
              </el-input>
            </div>
          </div>
          <div class="calendar-dettaglio-diario">
            <span class="info-diario">{{ $t('trasferte.authDiary') }}</span>

            <el-table :data="diario" row-class-name="single riga-hover" row-key="id" :empty-text="$t('msg.noDocFound')"
              v-loading="loading_diario" class="custom-table">


              <el-table-column width="50">
                <template slot-scope="scope">
                  <div class="data-wrapper">
                    <el-tooltip class="item" effect="dark" :content="$t('statusDett.' + scope.row.statoAvanz)"
                      placement="top-start">
                      <icon :name="getStatoIcon_dett(scope.row.statoAvanz)"
                        :class="getStatoClass_dett(scope.row.statoAvanz)" scale="1.2"></icon>
                    </el-tooltip>
                  </div>
                </template>

              </el-table-column>
              <el-table-column header-align="center" align="center" :label="$t('trasferte.giorno')" width="100">

                <template slot-scope="scope">
                  <div class="data-wrapper">
                    {{ scope.row.giorno | formatDate }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column header-align="center" align="center" :label="$t('trasferte.orario')" width="100">

                <template slot-scope="scope">
                  <div class="data-wrapper">
                    {{ scope.row.oraDal | formatHours }} / {{ scope.row.oraAl | formatHours }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column header-align="center" align="center" :label="$t('trasferte.destinazione')"
                min-width="200">

                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ scope.row.desDest === undefined ? scope.row.desMan : scope.row.desDest }}
                  </div>
                </template>

              </el-table-column>

              <el-table-column width="50">
                <template slot-scope="scope">
                  <div class="data-wrapper" style="cursor: pointer">
                    <icon slot="reference" class="confirm"
                      v-if="giorno[activity_select].ifMod === 'Y' && scope.row.statoAvanz === '1'"
                      @click.native.stop="save_diario(scope.row, '3')" name="riv-tick" scale="1.2"></icon>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="50">
                <template slot-scope="scope">
                  <div class="data-wrapper" style="cursor: pointer">
                    <icon slot="reference" class="reject"
                      v-if="giorno[activity_select].ifMod === 'Y' && scope.row.statoAvanz === '1'"
                      @click.native.stop="save_diario(scope.row, '2')" name="elm-chiudi" scale="1.2"></icon>
                  </div>
                </template>
              </el-table-column>
              <!--<el-table-column
                width="50">
                <template slot-scope="scope">
                  <div class="data-wrapper" style="cursor: pointer">
                    <el-popconfirm
                      :confirm-button-text="$t('btn.yes')"
                        :cancel-button-text="$t('btn.no')"
                        icon="el-icon-info"
                        icon-color="red"
                        :title="$t('trasferte.respAppDiary')"
                        @onConfirm="save_diario(scope.row,'3')">
                        <icon slot="reference" class="confirm"
                          v-if="scope.row.statoAvanz === '1'"
                          name="riv-tick" scale="1.2"></icon>
                      </el-popconfirm>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                width="50">
                <template slot-scope="scope">
                  <div class="data-wrapper" style="cursor: pointer">
                    <el-popconfirm
                        :confirm-button-text="$t('btn.yes')"
                        :cancel-button-text="$t('btn.no')"
                        icon="el-icon-info"
                        icon-color="red"
                        :title="$t('trasferte.respRejDiary')"
                        @onConfirm="save_diario(scope.row,'2')">
                        <icon slot="reference" class="reject"
                          v-if="scope.row.statoAvanz === '1'"
                          name="elm-chiudi" scale="1.2"></icon>
                      </el-popconfirm>
                  </div>
                </template>
              </el-table-column>-->
            </el-table>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button class="WEB-button WEB-button-alternative"
            v-if="giorno[activity_select].ifMod === 'Y' && trasferta.statoAvanz === '1'" @click="save_trasferta('2')">
            {{ $t('btn.rifiuta').toUpperCase() }}
          </el-button>
          <el-tooltip class="item" effect="dark" content="Prova 2" placement="top-start">
            <el-button class="WEB-button WEB-button-primary"
              v-if="giorno[activity_select].ifMod === 'Y' && trasferta.statoAvanz === '1'" @click="save_trasferta('3')"
              :disabled="!diario_toApprove">
              {{ $t('btn.approva').toUpperCase() }}
            </el-button>
          </el-tooltip>
        </span>
      </div>
      <!-- TRASFERTA END -->
      <!-- FERIE START -->
      <div
        v-if="giorno.length > 0 && (giorno[activity_select].macrotype === 'FERIE') && giorno[activity_select].id !== ''"
        v-loading="load_activity">
        <el-form class="WEB-form">
          <div class="elemento row row-custom">
            <div class="WEB-form-label col-8">
              {{ $t('ferie.tipologia') }}
            </div>
            <div class="WEB-form-value col-16">
              {{ ferie.descTipoAssenza }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="filtro.country === '2'">
            <div class="WEB-form-label col-8">
              {{ $t('ferie.cpf') }}
            </div>
            <div class="WEB-form-value col-16">
              {{ (ferie.rinunciaFraz === '1') ? $t('calendarioFerie.si').toUpperCase() :
                $t('calendarioFerie.no').toUpperCase() }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="WEB-form-label col-8">
              {{ $t('ferie.periodo') }}
            </div>
            <div class="WEB-form-value col-16">
              {{ ferie | getPeriodo }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="ferie.seOre === 'S'">
            <div class="WEB-form-label col-8">
              {{ $t('ferie.orario') }}
            </div>
            <div class="WEB-form-value col-16">
              {{ ferie | getOrario }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="ferie.seOre === 'S'">
            <div class="WEB-form-label col-8">
              {{ $t('ferie.numOre') }}
            </div>
            <div class="WEB-form-value col-16">
              {{ (ferie.oreAssenza != undefined) ? ferie.oreAssenza : ferie.oreAssenza }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="WEB-form-label col-8">
              {{ $t('ferie.noteDip') }}
            </div>
            <div class="WEB-form-value col-16">
              {{ ferie.notaDip }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="WEB-form-label col-8">
              {{ $t('ferie.noteResp') }}
            </div>
            <div class="WEB-form-value col-16" v-if="giorno[activity_select].ifMod === 'Y' && ferie.seGest === 'S'">
              <el-input type="text" maxlength="60" placeholder="" v-model="ferie.notaResp">
              </el-input>
            </div>
            <div class="WEB-form-value col-16" v-else>
              {{ ferie.notaResp }}
            </div>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button class="WEB-button WEB-button-alternative"
            v-if="giorno[activity_select].ifMod === 'Y' && ferie.seGest === 'S'" @click="save_ferie('R')">
            {{ $t('btn.rifiuta').toUpperCase() }}
          </el-button>
          <el-button class="WEB-button WEB-button-primary"
            v-if="giorno[activity_select].ifMod === 'Y' && ferie.seGest === 'S'" @click="save_ferie('C')">
            {{ $t('btn.approva').toUpperCase() }}
          </el-button>
        </span>
      </div>
      <!-- FERIE END -->
      <!-- DELEGHE START -->
      <div
        v-if="giorno.length > 0 && (giorno[activity_select].macrotype === 'DELSIND') && giorno[activity_select].id !== ''"
        v-loading="load_activity">
        <el-form class="WEB-form">
          <div class="elemento row row-custom">
            <div class="WEB-form-label col-8">
              {{ $t('delSind.tipologia') }}
            </div>
            <div class="WEB-form-value col-16">
              {{ delSind.descrizione }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="WEB-form-label col-8">
              {{ $t('delSind.periodo') }}
            </div>
            <div class="WEB-form-value col-16">
              {{ delSind | getPeriodo }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="WEB-form-label col-8">
              {{ $t('delSind.orario') }}
            </div>
            <div class="WEB-form-value col-16">
              {{ delSind | getOrario }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="WEB-form-label col-8">
              {{ $t('delSind.numOre') }}
            </div>
            <div class="WEB-form-value col-16">
              {{ delSind.oreAssenza }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="WEB-form-label col-8">
              {{ $t('delSind.oreLavCell') }}
            </div>
            <div class="WEB-form-value col-16">
              {{ delSind.oreLav }}
            </div>
          </div>
        </el-form>
      </div>
      <!-- FERIE END -->
      <!-- ALTRO START -->
      <div v-if="giorno.length > 0 && giorno[activity_select].id === ''" v-loading="load_activity">
        <el-form class="WEB-form">
          <div class="elemento row row-custom">
            <div class="WEB-form-label col-8">
              {{ $t('calendar.note') }}
            </div>
            <div class="WEB-form-value col-16">
              {{ giorno[activity_select].ore === '' ? giorno[activity_select].note : giorno[activity_select].ore + ' - '
                +
                giorno[activity_select].note }}
            </div>
          </div>
        </el-form>
      </div>
      <!-- ALTRO END -->
    </el-dialog>

    <!-- MODAL LEGENDA -->
    <el-dialog :title="($t('btn.legenda'))" :visible.sync="showModalLegenda" class="custom-dialog WEB-dialog"
      :append-to-body="true" custom-class="offset-7 col-10">

      <el-form class="WEB-form-legenda">
        <div v-for="(type) in legenda" :key="type.codice" class="WEB-form-legenda-row" v-show="type.codice !== '*'">
          <div class="tipologia" :class="'type_' + type.codice">
            <span>{{ type.codice }}</span>
          </div>
          <div class="label">
            {{ type.descrizione }}
          </div>
        </div>
        <div class="WEB-form-legenda-row">
          <div class="tipologia sta_A">
            <span></span>
          </div>
          <div class="label">
            {{ $t('calendar.toApp') }}
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['contenitoreHeight'],
  components: {},
  name: 'Calendar',

  data() {
    return {
      // filtri
      filtriActive: false,
      filtro: {
        country: {},
        countrySearch: '',
        date: '',
        typologies: [],
        company: '',
        group: '',
        cecoCoi: '',
        vip: false,
        cognome: '',
        employee: {},
        employeeTable: ''
      },
      loading_employee: false,
      loading: false,
      loading_giorno: false,
      reloadCalendar: false,
      // attività del giorno
      employee: '',
      giorno: [],
      activity_select: 0,
      load_activity: false,
      showModalGiorno: false,
      tabActivity: '0',
      // trasferta
      trasferta: {},
      diario: [],
      loading_diario: false,
      diario_toApprove: false,
      // ferie/assenze
      ferie: {},
      // deleghe sindacali
      delSind: {},
      // altro
      showModalLegenda: false,
      pag_for: 40,
      currentPage: 1,
      nrPages: 0,
      nrItems: 0,
      countries: [],
      calendario: [],
      tbl_calendario: [],
      counter: 0,
      list_Typologies: [],
      legenda: [],
      list_Company: [],
      list_Groups: [],
      list_CecoCoi: [],
      list_Employees: [],
      calendarioAttrib: {},
      giorni: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31']
    }
  },
  filters: {
    formatDate: function (date) {
      if (date !== '' && date !== undefined && date !== null) {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return '-'
      }
    },
    formatHours: function (hours) {
      if (hours !== '') {
        return hours.replace(',', ':')
      } else {
        return ' '
      }
    },
    formatMotivo: function (nota) {
      return nota !== undefined ? nota.replace(/\\n|\\r\\n|\\n\\r|\\r/g, '<br>') : ''
    },
    getPeriodo: function (row) {
      if (row.data) {
        return row.data !== '' ? moment(row.data, "YYYYMMDD").format("DD/MM/YYYY") : ''
      } else if (row.dataDal === undefined || row.dataAl === undefined) {
        return ''
      } else if (row.dataDal === row.dataAl) {
        return row.dataDal.substr(6, 2) + '/' + row.dataDal.substr(4, 2) + '/' + row.dataDal.substr(0, 4)
      } else {
        return row.dataDal.substr(6, 2) + '/' + row.dataDal.substr(4, 2) + '/' + row.dataDal.substr(0, 4) + ' - ' +
          row.dataAl.substr(6, 2) + '/' + row.dataAl.substr(4, 2) + '/' + row.dataAl.substr(0, 4)
      }
    },
    getOrario: function (row) {
      if (row.oraIni === undefined || row.oraFin === undefined) {
        return ''
      } else if (row.oraIni === '0,00' && row.oraFin === '0,00') {
        return ''
      } else if (row.oraIni !== '' && row.oraFin !== '') {
        return (row.oraIni.length === 4 ? '0' + row.oraIni : row.oraIni) + ' - ' + (row.oraFin.length === 4 ? '0' + row.oraFin : row.oraFin)
      } else {
        return ''
      }
    }
  },
  activated: function () {
    let date = new Date()
    let year = date.getFullYear().toString()
    let month = date.getMonth() + 1
    if (month < 10) {
      month = '0' + month.toString()
    } else {
      month = month.toString()
    }
    this.$set(this.filtro, 'date', year + month)
    this.load_Countries(true)
    //this.load_Employees(false)
  },
  deactivated: function () {
    // Filtri
    let filtro = {
      country: {},
      countrySearch: '',
      date: '',
      typologies: [],
      company: '',
      group: '',
      cecoCoi: '',
      vip: false,
      employee: {},
      employeeTable: ''
    }
    this.$set(this, 'filtro', filtro)
    this.filtriActive = false
    this.loading = false
    this.reloadCalendar = false
    // attività del giorno
    this.loading_giorno = false
    this.employee = ''
    this.$set(this, 'giorno', [])
    this.activity_select = 0
    this.load_activity = false
    this.showModalGiorno = false
    this.tabActivity = 0
    // trasferta
    this.$set(this, 'trasferta', {})
    this.$set(this, 'diario', [])
    this.loading_diario = false
    this.diario_toApprove = false
    // ferie/assenze
    this.$set(this, 'ferie', {})
    // deleghe sindacali
    this.$set(this, 'delSind', {})
    // altro
    this.pag_for = 40
    this.currentPage = 1
    this.nrPages = 0
    this.nrItems = 0
    this.counter = 0
    this.$set(this, 'countries', [])
    this.$set(this, 'calendario', [])
    this.$set(this, 'tbl_calendario', [])
    this.$set(this, 'list_Typologies', [])
    this.$set(this, 'legenda', [])
    this.$set(this, 'list_Company', [])
    this.$set(this, 'list_Groups', [])
    this.$set(this, 'list_CecoCoi', [])
    this.$set(this, 'list_Employees', [])
    this.$set(this, 'calendarioAttrib', {})
  },
  mounted: function () {
  },
  methods: {
    closeModalGiorno: function (done) {
      this.showModalGiorno = false
      this.employee = ''
      this.$set(this, 'trasferta', {})
      this.$set(this, 'diario', [])
      this.$set(this, 'ferie', {})
      this.$set(this, 'delSind', {})
      if (this.reloadCalendar) {
        this.reloadCalendar = false
        this.ricerca()
      }
    },
    // GESTIONE FILTRI
    openFiltri: function () {
      this.filtriActive = true
    },
    closeFiltri: function () {
      this.filtriActive = false
    },
    svuotaCampi: function () {
      this.$set(this.filtro, 'company', '')
      this.$set(this, 'list_Groups', [])
      this.$set(this.filtro, 'group', '')
      this.$set(this, 'list_CecoCoi', [])
      this.$set(this.filtro, 'cecoCoi', '')
      this.$set(this.filtro, 'typologies', [])
      this.filtro.typologies.push('*')
    },
    changeCountry: function (ricerca) {
      this.$set(this.filtro, 'vip', false)
      this.load_Typologies(ricerca)
      this.load_Company()
      //this.load_Employees()
    },
    changeCompany: function () {
      if (this.filtro.company === '') {
        this.$set(this, 'list_Groups', [])
        this.$set(this.filtro, 'group', '')
        this.$set(this, 'list_CecoCoi', [])
        this.$set(this.filtro, 'cecoCoi', '')
        this.$set(this, 'list_Employees', [])
        this.$set(this.filtro, 'employee', '')
      } else {
        this.load_Groups()
        this.load_CecoCoi()
        //this.load_Employees()
      }
    },
    selectEmployee: function () {
      console.log('selectEmployee')
      if (this.filtro.employee.country !== undefined) {
        let country = this.countries.find(el => el.codice === this.filtro.employee.country)
        this.$set(this.filtro, 'country', country)
        this.$set(this, 'list_Groups', [])
        this.$set(this.filtro, 'group', '')
        this.$set(this, 'list_CecoCoi', [])
        this.$set(this.filtro, 'cecoCoi', '')
        this.$set(this.filtro, 'typologies', [])
        this.changeCountry(false)
      } else {
        this.$set(this, 'list_Employees', [])
      }
    },
    load_Countries: function (ricerca) {
      this.$set(this, 'countries', [])
      this.$http.get('calendar/' + this.$store.state.country + '/countries', {
        params: {
          codLang: sessionStorage.getItem('codLang')
        }
      })
        .then(response => {
          if (response.body.rc === 0 || response.body.rc === '0') {
            this.$set(this, 'countries', response.body.data)
            let country = {}
            country = this.countries.map(country => {
              if (country.codice === this.$store.state.country) {
                return country
              }
            })
            if (country.length === 1) {
              this.$set(this.filtro, 'country', country[0])
              // Richiamo il servizio con l'elenco delle richieste solo se è resonsabile della propria country
              this.load_Typologies(ricerca)
              this.load_Company()
              //this.load_Employees()
            } else if (response.body.data.length >= 1) {
              this.$set(this.filtro, 'country', response.body.data[0])
              // Richiamo il servizio con l'elenco delle richieste nel caso in cui si è responsabile di più country impostando la prima
              this.load_Typologies(ricerca)
              this.load_Company()
              //this.load_Employees()
            } else {
              // nessuna country associata
              this.$set(this.filtro, 'country', {})
            }
          }
          //this.loading = false
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: process.env.duration
          })
          this.loading = false
        })
    },
    load_Company: function (ricerca) {
      this.$set(this, 'list_Company', [])
      this.$set(this.filtro, 'company', '')
      let country = this.filtro.country.codice
      this.$http.get('calendar/' + country + '/company', {
        params: {
          codLang: sessionStorage.getItem('codLang')
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'list_Company', response.body.data)
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: process.env.duration
          })
        })
    },
    load_Groups: function () {
      this.$set(this, 'list_Groups', [])
      this.$set(this.filtro, 'group', '')
      let country = this.filtro.country.codice
      this.$http.get('calendar/' + country + '/groups', {
        params: {
          codLang: sessionStorage.getItem('codLang'),
          company: this.filtro.company
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'list_Groups', response.body.data)
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: process.env.duration
          })
        })
    },
    load_CecoCoi: function () {
      this.$set(this, 'list_CecoCoi', [])
      this.$set(this.filtro, 'cecoCoi', '')
      let country = this.filtro.country.codice
      this.$http.get('calendar/' + country + '/cecocoi', {
        params: {
          codLang: sessionStorage.getItem('codLang'),
          company: this.filtro.company
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'list_CecoCoi', response.body.data)
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: process.env.duration
          })
        })
    },
    load_Employees: function (query) {
      this.$set(this, 'list_Employees', [])
      this.$set(this, 'loading_employee', true)

      this.$set(this.filtro, 'employee', '')
      let country = this.filtro.country.codice
      this.$http.get('calendar/' + country + '/listDipenInt', {
        params: {
          codLang: sessionStorage.getItem('codLang'),
          name: query
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'list_Employees', response.body.data)
          }
          this.$set(this, 'loading_employee', false)
        })
        .catch(error => {
          this.$set(this, 'loading_employee', false)
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: process.env.duration
          })
        })
    },
    load_Typologies: function (ricerca) {
      this.$set(this, 'list_Typologies', [])
      this.$set(this, 'legenda', [])
      this.$set(this.filtro, 'typologies', [])
      let country = this.filtro.country.codice
      this.$http.get('calendar/' + country + '/typologies', {
        params: {
          codLang: sessionStorage.getItem('codLang')
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            let typeAll = {
              codice: "*",
              descrizione: this.$t('calendar.all')
            }
            this.$set(this, 'legenda', response.body.data)
            // this.$set(this, 'list_Typologies', response.body.data)
            this.list_Typologies = response.body.data.filter((element) => {
              if (element.codice !== 'P') {
                return element
              }
            })
            this.list_Typologies.unshift(typeAll)
            this.filtro.typologies.push(typeAll.codice)
            //this.filtro.typologies.push('*')
            /*this.list_Typologies.forEach(
              (element) => {
                if (element.codice === '*') {
                  this.filtro.typologies.push(element.codice)
                }
              })*/
            if (ricerca) this.cerca()
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: process.env.duration
          })
        })
    },
    removell: function (value) {
      console.log(value)
      /*if (value === '*') {
        this.$set(this.filtro, 'typologies', [])
      }*/
    },
    changeAll: function (value) {
      if (value[value.length - 1] === '*') {
        this.$set(this.filtro, 'typologies', [])
        this.filtro.typologies.push('*')
      } else if (value[0] === '*') {
        this.filtro.typologies.shift()
      }
    },
    changeMonth: function (value) {
      let mese = moment(this.filtro.date + '01');
      this.$set(this.filtro, 'date', mese.add(value, 'months').format('YYYYMM'))
      this.currentPage = 1
      this.ricerca()
    },
    cerca: function () {
      this.currentPage = 1
      this.filtriActive = false
      this.ricerca()
    },
    // END GESTIONE FILTRI
    ricerca: function () {
      this.loading = true
      let country = ''
      //if (this.filtro.employee.country !== undefined) {
      //  country = this.filtro.employee.country
      //  this.countrySearch = this.filtro.employee.country
      //} else {
      country = this.filtro.country.codice
      this.countrySearch = this.filtro.country.codice
      //}

      if (country === '1') {
        this.counter = 3
      } else if (country === '2') {
        this.counter = 3
      } else if (country === '3') {
        this.counter = 2
      } else if (country === '4') {
        this.counter = 4
      } else if (country === '5') {
        this.counter = 1
      }

      this.$http.get('calendar/' + country + '/calendar', {
        params: {
          pag_action: (this.currentPage === 1) ? 'BEGIN' : 'NEXT',
          //pag_for: country === '5' ? 40 : this.pag_for,
          codLang: sessionStorage.getItem('codLang'),
          pag_for: this.pag_for,
          pag_from: this.currentPage,
          date: this.filtro.date,
          type: this.filtro.vip ? 'VIP' : '',
          calendar: this.filtro.typologies.join("_"),
          typeExp: 'W',
          company: this.filtro.company,
          group: this.filtro.group,
          cecocoi: this.filtro.cecoCoi,
          employee: this.filtro.employee.ccDipendente ? this.filtro.employee.ccDipendente : '',
          cognome: ''
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'calendario', response.body.data)
            this.$set(this, 'tbl_calendario', response.body.data)
            if (response.body.attrib !== undefined) {
              this.$set(this, 'calendarioAttrib', response.body.attrib)
            }
            if (this.currentPage === 1) {
              this.$set(this, 'nrPages', parseInt(response.body.attrib.pages))
              this.$set(this, 'nrItems', parseInt(response.body.attrib.size))
            }
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
            this.$set(this, 'calendario', [])
            this.$set(this, 'tbl_calendario', [])
            this.$set(this, 'calendarioAttrib', {})
            this.$set(this, 'nrPages', 0)
            this.$set(this, 'nrItems', 0)
          }
          this.loading = false
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: process.env.duration
          })
          this.$set(this, 'calendario', [])
          this.$set(this, 'tbl_calendario', [])
          this.$set(this, 'calendarioAttrib', {})
          this.$set(this, 'nrPages', 0)
          this.$set(this, 'nrItems', 0)
          this.loading = false
        })
    },
    stampa: function () {
      let nrItems = parseInt(this.calendarioAttrib.size)
      let type = this.filtro.vip ? 'VIP' : ''
      let country = this.filtro.country.codice
      let company = this.filtro.company
      let group = this.filtro.group
      let cecocoi = this.filtro.cecoCoi
      let codLang = sessionStorage.getItem('codLang')
      let url = ('download/calendar/' + country + '?nrItems=' + nrItems + '&date=' + this.filtro.date + '&type=' + type + '&calendar=' + this.filtro.typologies.join("_") + '&typeExp=P' +
        '&company=' + company + '&group=' + group + '&cecocoi=' + cecocoi + '&codLang=' + codLang + '&token=' + sessionStorage.getItem('token'))
      let win = window.open(process.env.baseUrlSpring + url, '_blank')
      win.focus()
    },
    changePage: function (page) {
      this.currentPage = page
      this.ricerca()
    },
    // CLICK SU GIORNO
    dettaglio: function (row, giorno) {
      if (row['day' + giorno] !== undefined) {
        this.load_dettaglio(row, giorno)
      } else {
        this.$set(this, 'giorno', [])
      }
      /*this.tabActivity = '0'
      this.activity_select = 0
      if (giorno.dett.length >= 1 && giorno.dett[0].type === 'T') {
        // Trasferta
        this.showModalGiorno = true
        this.load_trasferta(giorno.dett[0].id)
      } else if (giorno.dett.length >= 1 && giorno.dett[0].type === 'V') {
        this.showModalGiorno = true
        this.load_ferie(giorno.dett[0].id)
      }*/
    },
    load_dettaglio: function (row, giorno) {
      this.$set(this, 'giorno', [])
      let country = this.filtro.country.codice
      this.$http.get('calendar/' + country + '/dettday', {
        params: {
          codLang: sessionStorage.getItem('codLang'),
          ccSubordinato: row.ccDipendente,
          date: this.filtro.date + '' + giorno,
          calendar: this.filtro.typologies.join("_")
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'giorno', response.body.data)
            this.employee = row.surname + ' ' + row.name
            this.tabActivity = '0'
            this.activity_select = 0
            this.changeActivity(this.activity_select)
            this.showModalGiorno = true
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: process.env.duration
          })
        })
    },
    // MODAL
    changeActivity: function (index) {
      this.activity_select = index
      if (this.giorno[this.activity_select].macrotype === 'TRASFERTE' && this.giorno[this.activity_select].id !== '') {
        // Trasferta
        this.load_trasferta(this.giorno[this.activity_select].id)
      } else if (this.giorno[this.activity_select].macrotype === 'FERIE' && this.giorno[this.activity_select].id !== '') {
        // Ferie
        this.load_ferie(this.giorno[this.activity_select].id)
      } else if (this.giorno[this.activity_select].macrotype === 'DELSIND' && this.giorno[this.activity_select].id !== '') {
        // Deleghe Sindacali
        this.load_delSind(this.giorno[this.activity_select].id)
      }
      /*if (this.giorno[this.activity_select].type === 'T') {
        // Trasferta
        this.load_trasferta(this.giorno[this.activity_select].id)
      } else if (this.giorno[this.activity_select].type === 'V' || this.giorno[this.activity_select].type === 'L') {
        this.load_ferie(this.giorno[this.activity_select].id)
      }*/
    },
    // GESTIONE TRASFERTE
    load_trasferta: function (idTrasferta) {
      this.loading_giorno = true
      let country = this.filtro.country.codice
      this.$http.get('trasferte/' + country + '/trasferte', {
        params: {
          idTrasferta: idTrasferta,
          vista: 'C',
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.trasferta = response.body.data[0]
            this.loading_giorno = false
            //this.employee = this.trasferta.cognomeDip + ' ' + this.trasferta.nomeDip
            //this.showModalTrasferta = true
            this.load_diario('all')
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: process.env.duration
          })
          this.loading_giorno = false
        })
    },
    load_diario: function (stato) {
      this.diario_toApprove = false
      this.loading_diario = true
      this.$set(this, 'diario', [])
      let obj = {
        params: {
          'idTrasferta': this.trasferta.idTrasferta,
          'pag_action': 'BEGIN',
          'pag_from': 1,
          'pag_for': 99,
          'pag_order': 'DD',
          'vista': 'R',
          'ccDipendente': this.trasferta.ccDipendente,
          'dataDal': this.trasferta.dataDal,
          'dataAl': this.trasferta.dataAl
        }
      }
      if (stato !== '' && stato !== 'all') {
        obj.params['statoRighe'] = stato
      }
      let country = this.filtro.country.codice
      this.$http.get('trasferte/' + country + '/diario', obj)
        .then(response => {
          if (response.body.rc === 0) {
            let diarioCount = 0
            this.diario = response.body.data
            for (let i = 0; i < this.diario.length; i++) {
              diarioCount += this.diario[i].statoAvanz === '1' ? 1 : 0
            }
            this.diario_toApprove = (diarioCount === 0 ? true : false)
          } else {
            this.diario_toApprove = true
          }
          this.loading_diario = false
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: process.env.duration
          })
          this.loading_diario = false
        })
    },
    save_trasferta: function (statoAvanz) {
      this.loading_giorno = true
      let obj = {
        'idTrasferta': this.trasferta.idTrasferta,
        'operazione': '*UPD',
        'statoAvanz': statoAvanz,
        'notaRes': this.trasferta.notaRes
      }
      let country = this.filtro.country.codice
      this.$http.post('trasferte/' + country + '/trasferta', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            if (this.giorno.length === 1) {
              // ho solo un attività, chiudo la modal e ricalcolo il giorno
              this.loading_giorno = false
              this.reloadCalendar = false
              this.showModalGiorno = false
              this.$set(this, 'trasferta', {})
              this.$set(this, 'diario', [])
              //this.cerca()
              this.ricerca()
            } else {
              // ho più attività per il giorno, ricalcolo il mese alla chiusura della modal
              this.load_trasferta(this.trasferta.idTrasferta)
              this.reloadCalendar = true
            }
          } else {
            this.loading_giorno = false
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: process.env.duration
          })
          this.loading_giorno = false
        })
    },
    save_diario: function (row, statoAvanz) {
      this.loading_diario = true

      let obj = {
        idTrasferta: this.trasferta.idTrasferta,
        statoAvanz: statoAvanz,
        righeDiario: [{
          id: row.id
        }],
        numRigheDiario: 1
      }

      let country = this.filtro.country.codice
      this.$http.post('trasferte/' + country + '/statodiario', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.reloadCalendar = true
            this.load_diario()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading_diario = false
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: process.env.duration
          })
          this.loading_diario = false
        })
    },
    // FERIE
    load_ferie: function (idAssenza) {
      //this.showModalFerie = true
      this.load_activity = true
      this.loading_diario = true
      this.$set(this, 'ferie', {})
      let country = this.filtro.country.codice
      this.$http.get('ferie/' + country + '/richiestesub', {
        params: {
          pag_action: 'BEGIN',
          pag_for: 99,
          pag_from: 1,
          id: idAssenza,
          VIP: null
        }
      })
        .then(response => {
          if (response.body.rc === 0 && response.body.data && response.body.data.length >= 1) {
            this.$set(this, 'ferie', response.body.data[0])
            //this.employee = this.ferie.cognome + ' ' + this.ferie.nome
            //this.showModalFerie = true
          } else {
            this.$set(this, 'ferie', {})
          }
          this.load_activity = false
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: process.env.duration
          })
          this.load_activity = false
        })
    },
    save_ferie: function (stato) {
      this.load_activity = true
      let country = this.filtro.country.codice
      let obj = {
        notaRes: this.ferie.notaResp,
        id: this.ferie.id,
        stato: stato
      }
      this.$http.post('ferie/' + country + '/richiestaupdate', obj, { emulateJSON: true })
        .then(response => {
          if (response.body.rc === 0) {
            if (this.giorno.length === 1) {
              // ho solo un attività, chiudo la modal e ricalcolo il giorno
              this.load_activity = false
              this.reloadCalendar = false
              this.showModalGiorno = false
              this.$set(this, 'ferie', {})
              this.cerca()
            } else {
              // ho più attività per il giorno, ricalcolo il mese alla chiusura della modal
              this.reloadCalendar = true
              this.load_ferie(this.ferie.id)
            }
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    // DELSIND
    load_delSind: function (idRic) {
      //this.showModalFerie = true
      this.load_activity = true
      this.loading_diario = true
      this.$set(this, 'delSind', {})
      let country = this.filtro.country.codice
      this.$http.get('deleghesindacali/' + country + '/permesso', {
        params: {
          codLang: sessionStorage.getItem('codLang'),
          idRic: idRic
        }
      })
        .then(response => {
          if (response.body.rc === 0 && response.body.data) {
            this.$set(this, 'delSind', response.body.data)
          } else {
            this.$set(this, 'delSind', {})
          }
          this.load_activity = false
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: process.env.duration
          })
          this.load_activity = false
        })
    },
    changeRic: function (ric) {
      this.$set(this, 'ferie', ric)
    },
    getClassDay: function (day) {
      return 'type_' + day.type + (day.sta !== '' ? ' sta_' + day.sta : '')
    },
    getStatoIcon_dett: function (stato) {
      switch (stato) {
        case '0':
          return 'riv-save2'
        case '1':
          return 'riv-save2'
        case '2':
          return 'riv-user'
        case '3':
        case '4':
          return 'riv-alloggio'
        default:
          return ''
      }
    },
    getStatoClass_dett: function (stato) {
      switch (stato) {
        case '0':
          return 'status-saved'
        case '1':
          return 'status-send'
        case '2':
          return 'status-rejected'
        case '3':
          return 'status-approved'
        case '4':
          return 'status-send'
        default:
          return ''
      }
    },
    getCellClassName: function ({ row, column, rowIndex, columnIndex }) {
      let giorno = (columnIndex - this.counter).toString()
      if (parseInt(giorno) < 10) {
        giorno = '0' + giorno
      }
      if (this.tbl_calendario[rowIndex].hasOwnProperty('day' + giorno)) {
        let day = this.tbl_calendario[rowIndex]['day' + giorno]
        return 'type_' + day.type + (day.sta !== '' ? ' sta_' + day.sta : '') + (day.type !== '' ? ' pointer' : '')
      }
      return ''
    },
    getColumnCellClass: function (giorno) {
      let stringClass = ''
      if (this.calendarioAttrib.hasOwnProperty('fe' + giorno)) {
        stringClass = stringClass + 'ferie '
      }

      let date = new Date()
      if (moment(date).format('YYYYMMDD') === this.filtro.date + giorno) {
        stringClass = stringClass + 'today '
      }
      return stringClass
    },
    getTipology: function (activity) {
      let tipology = this.legenda.find(el => el.codice === activity.type)
      return tipology ? tipology['descrizione'] : activity.type
    },
    getClassToday: function (giorno) {
      let date = new Date()
      if (moment(date).format('YYYYMMDD') === this.filtro.date + giorno) {
        return 'Today'
      } else {
        return ''
      }
    },
    changeInput: function () {
      let list = []
      list = this.calendario.filter(item => {
        if (item.surname.includes(this.filtro.employeeTable.toUpperCase())) {
          return item
        }
      })
      this.$set(this, 'tbl_calendario', list)
    },
  }
}
</script>


<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/el-table.less";
@import "../../assets/less/el-pagination.less";
@import "../../assets/less/el-button.less";

.page-calendar {
  .WEB-actions {
    .prec {
      padding-right: 20px;
      float: none;
    }

    .succ {
      padding-right: 20px;
      float: none;
    }

    .el-date-editor {
      .el-input__inner:hover {
        cursor: pointer;
      }

      .el-input__inner {
        height: 22px;
        line-height: 22px;
        border: 0px;
        border-bottom: 1px solid #e7e7e7;
        border-radius: 0px;
        padding-left: 25px;
        padding-right: 10px;
        width: 150px;
        text-align: center;
      }

      .el-input__prefix {
        left: -5px;

        .el-input__icon {
          line-height: 22px;
        }
      }
    }

    .el-select {

      //margin-left: 20px;
      .el-input__inner {
        height: 22px;
        line-height: 22px;
        border: 0px;
        border-bottom: 1px solid #e7e7e7;
        border-radius: 0px;
        padding-left: 0px;
        padding-right: 10px;
      }

      .el-input__suffix {
        right: -5px;
      }
    }

    .el-checkbox {
      .el-checkbox__inner {
        border-radius: 0px;
      }

      &.is-checked {
        .el-checkbox__inner {
          background-color: @greenRiva;
          border-color: @greenRiva;
        }
      }
    }

    .header-label {
      .set-font(@size: 14px; @weight: bold);
    }

    .header-value {
      .set-font(@size: 14px; @color: #666);
    }

    .action {
      float: right;
      text-align: right;
    }
  }

  .table-ferie {
    margin-top: 20px;
    // WEB-header (56px) - WEB-title (50px) WEB-Action (50px) WEB-paginator (60px) - MArgin-top (10px)
    height: calc(100vh - 56px - 50px - 50px - 60px - 5px - 10px);
  }

  .el-table {

    //margin-bottom: 10px;
    .el-table__header-wrapper {
      .el-table__header {
        border-top: 1px solid @greenRiva;

        //border-bottom: 1px solid @greenRiva;
        thead {
          tr {
            height: 36px;

            th {
              padding: 0px;

              &:not(.is-sortable) {
                .cell {
                  margin-top: 0;
                }
              }

              &.today {
                background-color: #007c74;

                .label-giorno {
                  color: #FFFFFF !important;
                }

                .numero {
                  color: #FFFFFF !important;
                }
              }

              .cell {
                line-height: 10px;
                padding: 2px;
                .set-font(@size: 12px; @weight: bold);

                .header-giorni {
                  width: 100%;
                  padding: 0px;
                  line-height: 0px;

                  .label-giorno {
                    text-align: center;
                    .set-font(@size: 12px; @weight: bold; @color: @greenRiva);
                    line-height: 18px;
                  }

                  .numero {
                    text-align: center;
                    .set-font(@size: 12px; @weight: bold; @color: @greenRiva);
                    line-height: 18px;
                  }
                }
              }

              .filtro-employee {
                width: 100% !important;
                height: 30px;

                input {
                  height: 30px;
                  font-family: "os-regular";
                  font-weight: normal;
                  font-size: 11px;
                  color: #666;
                  line-height: 15px;

                  &:focus {
                    border-color: #007c74 !important;
                    outline: 0;
                  }
                }
              }
            }
          }
        }
      }
    }

    .el-table__body-wrapper {
      .el-table__body {
        tbody {
          tr {
            height: 30px;

            td {
              padding: 0px;

              .cell {
                padding: 0px !important;
                .set-font(@size: 11px; @color: #666);
                line-height: 15px;

                .name-wrapper {
                  padding-left: 2px;
                }

                .ferie {
                  background-color: red;
                }

                .giorno {
                  height: 30px;
                  line-height: 30px;
                }
              }

              &.ferie {
                background-color: #ccc;
              }

              &.sta_A {
                // Richeista in Attesa di Approvazione
                border: 1px Dashed #ff0000;
              }

              &.type_V {
                background-color: #f8cbad;
              }

              &.type_T {
                background-color: #ffff66;
              }

              &.type_Q {
                background-color: #8ffffb;
              }

              &.type_M {
                background-color: #ff3f3f;
              }

              &.type_I {
                background-color: #ff960e;
              }

              &.type_F {
                background-color: #1fdb77;
              }

              &.type_R {
                background-color: #a1a1a1;
              }

              &.type_C {
                background-color: #15b300;
              }

              &.type_S {
                background-color: #008ce5;
              }

              &.type_O {
                background-color: #ff92e4;
              }

              &.type_A {
                background-color: #c8c100;
              }

              &.type_L {
                background-color: #d9d9d9;
              }

              &.type_B {
                background-color: #c074e0;
              }

              &.type_D {
                background-color: #31b7bc !important;
              }

              &.type_P {
                background-color: #fff;

                .cell {
                  color: #fff;
                }
              }

              &.pointer {
                cursor: pointer;
              }
            }
          }

          tr:hover>td {
            background-color: initial !important;
            cursor: auto;

            &.ferie {
              background-color: #ccc !important;
            }

            &.sta_A {
              // Richeista in Attesa di Approvazione
              border: 1px Dashed #ff0000 !important;
            }

            &.type_V {
              background-color: #f8cbad !important;
            }

            &.type_T {
              background-color: #ffff66 !important;
            }

            &.type_Q {
              background-color: #8ffffb !important;
            }

            &.type_M {
              background-color: #ff3f3f !important;
            }

            &.type_I {
              background-color: #ff960e !important;
            }

            &.type_F {
              background-color: #1fdb77 !important;
            }

            &.type_R {
              background-color: #a1a1a1 !important;
            }

            &.type_C {
              background-color: #15b300 !important;
            }

            &.type_S {
              background-color: #008ce5 !important;
            }

            &.type_O {
              background-color: #ff92e4 !important;
            }

            &.type_A {
              background-color: #c8c100 !important;
            }

            &.type_L {
              background-color: #d9d9d9 !important;
            }

            &.type_B {
              background-color: #c074e0 !important;
            }

            &.type_D {
              background-color: #31b7bc !important;
            }

            &.type_P {
              background-color: #fff !important;

              .cell {
                color: #fff !important;
              }
            }

            &.pointer {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}

.el-tabs-ferie {
  margin-bottom: 10px;
  padding: 0;

  .el-tabs__header {
    border-bottom: 1px solid #ccc;
    margin-bottom: 0px;

    .el-tabs__nav-wrap {
      margin-top: 0px;
    }

    .el-tabs__nav-wrap::after {
      display: none;
    }

    .el-tabs__nav {
      border: 0px;
      height: 33px;

      .el-tabs__item {
        text-align: center;
        padding-left: 0px;
        padding-right: 0px;
        border: 0px;
        height: 30px;
        line-height: 30px;
        .set-font(@color: #999);
        letter-spacing: 1px;

        .app-name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 5px;
        }

        &.is-active {
          .set-font(@weight: bold);

          // background-color: #efe8da;
          .barra {
            background-image: linear-gradient(to right, @oroRiva, @greenRiva);
            height: 3px;
          }
        }
      }

      .el-tabs__item:hover {
        color: @greenRiva;
      }
    }
  }
}

.calendar-dettaglio-diario {
  padding-top: 10px;

  .info-diario {
    display: block;
    height: 30px;
    text-align: center;
    line-height: 30px;
    font-family: "os-regular";
    font-weight: normal;
    font-size: 14px;
    color: #454848;
  }
}

.status-saved {
  color: @grayMedium;
}

.status-send {
  color: @orangeMedium;
}

.status-approved {
  color: @greenApproved
}

.status-rejected,
.status-delete {
  color: #f44336
}

.WEB-form-legenda {
  display: table;

  .WEB-form-legenda-row {
    float: left;
    line-height: 40px;
    height: 40px;
    width: 50%;

    .tipologia {
      float: left;
      height: 34px;
      width: 34px;
      margin-top: 3px;
      border: 1px solid #EBEEF5;
      margin-right: 20px;

      span {
        line-height: 34px;
        height: 34px;
        width: 34px;
        display: block;
        text-align: center;
        font-family: "os-regular";
        font-weight: normal;
        font-size: 13px;
        color: #666;
      }

      &.type_V {
        background-color: #f8cbad !important;
      }

      &.type_T {
        background-color: #ffff66 !important;
      }

      &.type_Q {
        background-color: #8ffffb !important;
      }

      &.type_M {
        //background-color: #c8c100 !important;
        background-color: #ff3f3f !important;
      }

      &.type_I {
        background-color: #ff960e !important;
      }

      &.type_F {
        background-color: #1fdb77 !important;
      }

      &.type_R {
        background-color: #a1a1a1 !important;
      }

      &.type_C {
        background-color: #15b300 !important;
      }

      &.type_S {
        background-color: #008ce5 !important;
      }

      &.type_O {
        background-color: #ff92e4 !important;
      }

      &.type_A {
        //background-color: #ff3f3f !important;
        background-color: #c8c100 !important;
      }

      &.type_L {
        background-color: #d9d9d9 !important;
      }

      &.type_B {
        background-color: #c074e0 !important;
      }

      &.type_D {
        background-color: #31b7bc !important;
      }

      &.type_P {
        background-color: #fff !important;

        span {
          color: #fff !important;
        }
      }

      &.sta_A {
        // Richeista in Attesa di Approvazione
        border: 1px Dashed #ff0000;
      }
    }

    .label {
      font-family: "os-regular";
      font-weight: normal;
      font-size: 13px;
      color: #007c74;
      display: inline;
      text-align: right;
      line-height: 16px;
      height: 30px;
      line-height: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Calendar/Calendar.vue